import {createAsyncThunk} from '@reduxjs/toolkit';
import {integrationsApi} from 'api';
import {toastNotificationManager} from 'toast-notifications';
import {IUpdateIntegrationPayload} from 'models/integrations';
import {prefix} from './config';

interface IUpdatePayload {
  integrationId: string;
  payload: IUpdateIntegrationPayload;
}

export const updateIntegrationThunk: any = createAsyncThunk(
  `${prefix} updateIntegration`,
  async ({integrationId, payload}: IUpdatePayload, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await integrationsApi.updateIntegration(integrationId, payload);
      return parsedBody;
    } catch (error) {
      dispatch(toastNotificationManager.createErrorToastAction(error.parsedBody));
      return rejectWithValue({error});
    }
  }
);
